import React from 'react'
import CustomLink from 'src/utils/customLink'
import Download from 'src/images/svgs/Download.svg'
import Eyebrow from 'src/images/svgs/EyebrowGold.svg'
import { PrismicStructuredTextType } from 'src/typings/generated/graphql'
import { PrismicRichText } from '@prismicio/react'
import * as Styles from './downloadAssets.module.scss'

export type DownloadAssetsFile = {
  fileLabel: PrismicStructuredTextType | null
  fileImage: {
    url?: string | null
    size?: string | null
  }
  file: {
    url?: string | null
    name?: string | null
    size?: number | null
  } | null
}

export type DownloadAssetsContent = {
  label: PrismicStructuredTextType | null
  files: DownloadAssetsFile[]
}

type Props = {
  content: DownloadAssetsContent
}

const DownloadAssets = ({ content }: Props) => {
  const { label, files } = content

  if (!files || files.length === 0) return null

  // Helper function to format file size

  const fileItems = files.map(fileItem => {
    const fileUrl = fileItem.file?.url

    if (!fileUrl) return null

    // Extract filename from URL
    const fileName = fileUrl.split('/').pop()?.split('?')[0] || 'download'

    // Add dl parameter to force download for Prismic CDN URLs
    const separator = fileUrl.includes('?') ? '&' : '?'
    const downloadUrl = `${fileUrl}${separator}dl=${encodeURIComponent(
      fileName
    )}`

    // Generate unique key from URL
    const uniqueKey = `file-${fileUrl.replace(/[^a-zA-Z0-9]/g, '-')}`

    return (
      <div key={uniqueKey} className={Styles.fileItem}>
        <a
          href={downloadUrl}
          download={fileName}
          className={Styles.fileLink}
          target="_self"
          rel="noopener noreferrer"
        >
          {fileItem.fileImage?.url && (
            <img
              src={fileItem.fileImage.url}
              alt={fileItem.fileLabel?.richText?.[0]?.text || 'Download file'}
              className={Styles.fileImage}
            />
          )}
          <div className={Styles.fileInfo}>
            {fileItem.fileLabel && (
              <div className={Styles.fileLabel}>
                <PrismicRichText
                  field={fileItem.fileLabel.richText}
                  components={{
                    hyperlink: ({ node, children }: any) =>
                      CustomLink({ link: node.data, children }),
                  }}
                />
              </div>
            )}
            <div className={Styles.fileIcon}>
              <Download />
            </div>
          </div>
        </a>
      </div>
    )
  })

  return (
    <div className={Styles.downloadAssets}>
      <div className={Styles.eyebrow}>
        <Eyebrow />
      </div>
      {label && (
        <div className={Styles.label}>
          <PrismicRichText
            field={label.richText}
            components={{
              hyperlink: ({ node, children }: any) =>
                CustomLink({ link: node.data, children }),
            }}
          />
        </div>
      )}

      <div className={Styles.filesList}>{fileItems}</div>
    </div>
  )
}

export default DownloadAssets
